import { InstallationProductSyncModel } from "./installationProductSyncModel";

export class OfferInstallationSyncModel {
    public id: number;
    public offerInstallationType: number;
    public offerId: number;
    public pipeInstallTypeId: number;
    public installationProducts: Array<InstallationProductSyncModel>;
    public pipeInfo: string;
    public fittings: string;
    public activeTab: number;
}